const config = require('../../../../../config/locales_json/packs/private/users/update_password.json');
const language = $('body').data("language");

jQuery(document).ready(function () {
    var recruiterForm = $("#user_password_form")
    // Chequeamos que exista el elemento padre para realizar logicas
    if(recruiterForm.length > 0){
        $("#user_password_form .save-button").on("click", function(e){
            e.preventDefault()

            var password = $("#user_password_form #user_password")
            var passwordConfirmation = $("#user_password_form #user_password_confirmation")
            var error = checkPasswordValidation(password, passwordConfirmation)
            
            if(!error){
                const successText = getTranslationValue(config, [language, "on_click_save_button", "not_error_text"],"Actualizando...");
                $(this).text(successText).addClass("disabled")
                recruiterForm.addClass("disabled");
                recruiterForm.submit(); 
            } else {
                const swalFireText = getTranslationValue(config, [language, "on_click_save_button", "Swalfire_text"],"Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.");
                const swalFireConfirmButtonText = getTranslationValue(config, [language, "on_click_save_button", "Swalfire_confirmButton"],"Aceptar");

                Swal.fire({
                    text: swalFireText,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: swalFireConfirmButtonText,
                    customClass: {
                        confirmButton: "btn btn-fj-purple"
                    }
                }).then(function () {
                    KTUtil.scrollTop();
                });
            }	
        });
    }

    function checkPasswordValidation(password, passwordConfirmation) {
        var password = $(password)
        var passwordConfirmation = $(passwordConfirmation)
        var error = 0
        var contPasswordInput = password.parent();
        var contPasswordConfirmationInput = passwordConfirmation.parent();
    
        // Remueve el icono de alerta o success del input
        password.removeClass("is-invalid");
        password.removeClass("is-valid");
        // Remueve la clase de has-danger y has-success al contenedor del input
        contPasswordInput.removeClass("has-danger");
        contPasswordInput.removeClass("has-success");
        // Se busca el mensaje de error y lo elimina
        contPasswordInput.find(".fv-plugins-message-container").remove()
    
        // Remueve el icono de alerta o success del input
        passwordConfirmation.removeClass("is-invalid");
        passwordConfirmation.removeClass("is-valid");
        // Remueve la clase de has-danger y has-success al contenedor del input
        contPasswordConfirmationInput.removeClass("has-danger");
        contPasswordConfirmationInput.removeClass("has-success");
        // Se busca el mensaje de error y lo elimina
        contPasswordConfirmationInput.find(".fv-plugins-message-container").remove()

        // Si password esta vacio
        if(password.val().length == 0){
            // Mensaje de error
            const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "empty_password_error_text"],"Debe ingresar una nueva contraseña si desea actualizarla."); 
            var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
            // Agrega el icono al input
            password.addClass("is-invalid");
            // Agrega la clase de has-danger al contenedor del input
            contPasswordInput.addClass("has-danger");
            // Se muestra el mensaje de error
            contPasswordInput.append(errorMsg);
            // Le suma al contador de errores
            error++;
        // Si password tiene menos de 6 caracteres
        } else if(password.val().length < 6) {
            // Mensaje de error
            const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "short_password_error_text"],"La contraseña debe contener al menos 6 caracteres.");  
            var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
            // Agrega el icono al input
            password.addClass("is-invalid");
            // Agrega la clase de has-danger al contenedor del input
            contPasswordInput.addClass("has-danger");
            // Se muestra el mensaje de error
            contPasswordInput.append(errorMsg);
            // Le suma al contador de errores
            error++;
        } else {
            // Agrega el icono check al input
            password.addClass("is-valid");
            // Agrega la clase de has-success al contenedor del input
            contPasswordInput.addClass("has-success");
        }

        // Si password_confirmation no tiene caracteres
        if(password.val().length > 0 && passwordConfirmation.val().length == 0){
            // Mensaje de error
            const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "confirmation_password_not_chr_error_text"],"Las contraseñas no son iguales.");  
            var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
            // Agrega el icono al input
            passwordConfirmation.addClass("is-invalid");
            // Agrega la clase de has-danger al contenedor del input
            contPasswordConfirmationInput.addClass("has-danger");
            // Se muestra el mensaje de error
            contPasswordConfirmationInput.append(errorMsg);
            // Le suma al contador de errores
            error++;
        // Si password_confirmation esta vacio
        } else if(passwordConfirmation.val().length == 0){
            const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "confirmation_password_empty_error_text"],"Debe ingresar una nueva contraseña si desea actualizarla."); 
            var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
            // Agrega el icono al input
            passwordConfirmation.addClass("is-invalid");
            // Agrega la clase de has-danger al contenedor del input
            contPasswordConfirmationInput.addClass("has-danger");
            // Se muestra el mensaje de error
            contPasswordConfirmationInput.append(errorMsg);
            // Le suma al contador de errores
            error++;
        // Si password_confirmation y password no coinciden
        } else if(password.val() != passwordConfirmation.val()) {
            // Mensaje de error
            const errorText = getTranslationValue(config, [language, "checkPasswordValidation", "passwords_not_match_error_text"],"Las contraseñas no son iguales."); 
            var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
            // Agrega el icono al input
            passwordConfirmation.addClass("is-invalid");
            // Agrega la clase de has-danger al contenedor del input
            contPasswordConfirmationInput.addClass("has-danger");
            // Se muestra el mensaje de error
            contPasswordConfirmationInput.append(errorMsg);
            // Le suma al contador de errores
            error++;
        } else {
           // Agrega el icono check al input
           passwordConfirmation.addClass("is-valid");
           // Agrega la clase de has-success al contenedor del input
           contPasswordConfirmationInput.addClass("has-success");
        }

        return error;
    }
})

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}